import { RequiredDocumentEnum } from '../../../generated/graphql';

export const RequiredDocumentTypes = [
  { label: 'Паспорт', value: RequiredDocumentEnum.Passport },
  { label: 'ИНН', value: RequiredDocumentEnum.Inn },
  { label: 'Медицинская книжка', value: RequiredDocumentEnum.MedBook },
  { label: 'Платежная информация', value: RequiredDocumentEnum.PaymentInfo },
];
